import BaseService from "./BaseService";

export default class TransactionService extends BaseService {
    public static getTransactionHistory(token: string, postData: any, userId?: string) {
        let url = process.env.REACT_APP_API_URL + 'payment/transaction/all/history';

        if (userId) {
            url += `/${encodeURIComponent(userId)}`;
        }

        return BaseService.sendRequest(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static initiatetransaction(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/initiate/refund', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateFraud(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/updatefraudstatus', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
    public static getCompliance(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'support/get/v2', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
    public static updateCompliance(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'support/update', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    //CSV data download
    public static getTransactionHistoryForCSV(token: string, postData: any, userId?: string) {
        let url = process.env.REACT_APP_API_URL + 'payment/transaction/history/csv';
        if (userId) {
            url += `/${encodeURIComponent(userId)}`;
        }
        return BaseService.sendRequest(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getTransactionStatus(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/pause-transaction-status/get', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }
    public static UpdateTransactionStatus(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/pause-transaction-status/update', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getCardStatus(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/card-status', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }
    public static UpdateCardStatus(token: string, cardStatus: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + `payment/card-status/${cardStatus}`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }

    public static voidPayment(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/initiate/void-transaction', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static fetchTransactionStatusList(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/transaction-status-list', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }
    public static fetchWalletTransTypeList(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/wallet-trans-type-list', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    }
    public static getAdminWalletTransactionHistoryListWithBalance(token: string, postData: any) {
        let url = process.env.REACT_APP_API_URL + 'payment/wallet-transaction-history/admin/withbalance';
        return BaseService.sendRequest(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static sendReceipt(token: string, transferId: string) {
        let url = `${process.env.REACT_APP_API_URL}notification/send-notification/${transferId}`;
        return BaseService.sendRequest(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
    }
}